import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AssetColorLabel, GalleryColorLabel } from '@nusign/picflow-backend-types';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { TranslateLabelPipe } from '../../../shared/pipes/translate-label.pipe';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';
import { ColorLabelShortcutPipe } from '../../pipes/color-label-shortcut.pipe';

@Component({
  selector: 'app-color-label-context',
  templateUrl: './color-label-context.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonMenuItemComponent, TranslatePipe, TranslateLabelPipe, ColorLabelShortcutPipe],
})
export class ColorLabelContextComponent {
  @Input({ required: true }) colorLabels: GalleryColorLabel[] = [];
  @Input({ required: true }) currentColorLabel: AssetColorLabel;
  @Input({ required: true }) location: string;
  @Output() updateColorLabel = new EventEmitter<AssetColorLabel>();
}
